import { lazy } from 'react';
import { authRoles } from 'app/auth';

import ProductsLayout from './layouts/ProductsLayout';

const OrganisationProductsPage = lazy(() => import('./use-cases/OrganisationProductsPage'));
const PharmacyProductsPage = lazy(() => import('./use-cases/PharmacyProductsPage'));
const OrganisationAddProductsPage = lazy(() => import('./use-cases/OrganisationAddProductsPage'));
const OrganisationImportProductsPage = lazy(() =>
  import('./use-cases/OrganisationImportProductsPage')
);
const ProductLibraryPage = lazy(() => import('./use-cases/ProductLibraryPage'));
const ProductCategoriesPage = lazy(() =>
  import('./use-cases/ProductCategoriesPage/ProductCategoriesPage')
);
const UberSettingsPage = lazy(() => import('./use-cases/UberSettings/UberSettingsPage'));
const UberLaunchPage = lazy(() => import('./use-cases/UberLaunch/UberLaunchPage'));

const ProductsConfig = {
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            organisationSelector: true,
          },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'products/add-products',
      element: (
        <ProductsLayout>
          <OrganisationAddProductsPage />
        </ProductsLayout>
      ),
      settings: {
        layout: {
          config: {
            healtheraHeader: {
              display: true,
              options: {
                pharmacySelector: false,
                organisationSelector: false,
              },
            },
          },
        },
      },
    },
    {
      path: 'products/import-products',
      element: (
        <ProductsLayout>
          <OrganisationImportProductsPage />
        </ProductsLayout>
      ),
      settings: {
        layout: {
          config: {
            healtheraHeader: {
              display: true,
              options: {
                pharmacySelector: false,
                organisationSelector: false,
              },
            },
          },
        },
      },
    },
    {
      path: 'product-library',
      element: (
        <ProductsLayout>
          <ProductLibraryPage />
        </ProductsLayout>
      ),
      settings: {
        layout: {
          config: {
            healtheraHeader: {
              display: true,
              options: {
                pharmacySelector: false,
                organisationSelector: false,
              },
            },
          },
        },
      },
    },
    {
      path: 'product-categories',
      element: (
        <ProductsLayout>
          <ProductCategoriesPage />
        </ProductsLayout>
      ),
      settings: {
        layout: {
          config: {
            healtheraHeader: {
              display: true,
              options: {
                pharmacySelector: false,
                organisationSelector: false,
              },
            },
          },
        },
      },
    },
    {
      path: 'products',
      element: (
        <ProductsLayout>
          <OrganisationProductsPage />
        </ProductsLayout>
      ),
      settings: {
        layout: {
          config: {
            healtheraHeader: {
              display: true,
              options: {
                pharmacySelector: false,
                organisationSelector: true,
              },
            },
          },
        },
      },
    },
    {
      path: 'uber-settings',
      element: (
        <ProductsLayout>
          <UberSettingsPage />
        </ProductsLayout>
      ),
      settings: {
        layout: {
          config: {
            navbar: { display: false },
            healtheraHeader: {
              display: true,
              options: {
                pharmacySelector: false,
                organisationSelector: false,
              },
            },
          },
        },
      },
    },
    {
      path: 'uber-launch',
      element: <UberLaunchPage />,
      settings: {
        layout: {
          config: {
            navbar: { display: false },
            topBanner: { display: false },
            healtheraHeader: {
              display: true,
              options: {
                pharmacySelector: false,
                organisationSelector: false,
              },
            },
          },
        },
      },
    },
    {
      path: 'pharmacy-products',
      element: (
        <ProductsLayout>
          <PharmacyProductsPage />
        </ProductsLayout>
      ),
      settings: {
        layout: {
          config: {
            healtheraHeader: {
              display: true,
              options: {
                pharmacySelector: true,
                organisationSelector: false,
              },
            },
          },
        },
      },
    },
  ],
};

export default ProductsConfig;
